import React from 'react';
import { Link } from 'react-router-dom'; // Import Link

const TermsPage: React.FC = () => {
  return (
    // Apply the static-content-page class
    <div className="static-content-page">
      <h1>Terms and Conditions</h1>
      <p>
        Welcome to IntelPro. By accessing or using our website, you agree to comply with and be bound by the following terms and conditions. Please read them carefully.
      </p>
      <h2>1. Use of the Website</h2>
      <p>
        You agree to use this website only for lawful purposes and in a way that does not infringe the rights of, restrict, or inhibit anyone else's use and enjoyment of the website.
      </p>
      <h2>2. Intellectual Property</h2>
      <p>
        All content on this website, including text, graphics, logos, and images, is the property of IntelPro and is protected by copyright laws. You may not reproduce, distribute, or use any content without our prior written consent.
      </p>
      <h2>3. Limitation of Liability</h2>
      <p>
        IntelPro will not be liable for any damages arising from the use of this website, including but not limited to direct, indirect, incidental, punitive, and consequential damages.
      </p>
      <h2>4. Changes to Terms</h2>
      <p>
        We reserve the right to update these terms and conditions at any time. Your continued use of the website constitutes your acceptance of the updated terms.
      </p>
      <h2>5. Contact Us</h2>
      <p>
        If you have any questions about these terms, please contact us
        {/* Replace mailto link with internal Link */}
        &nbsp;via our <Link to="/contact">Contact Page</Link>.
      </p>
    </div>
  );
};

export default TermsPage;